import React from 'react'
import { useTranslation } from 'react-i18next'
import '@/static/styles/mobiscroll.react.min.css'
import '@/static/styles/mobiscroll-custom.css'

import mobiscroll from '@/libs/mobiscroll'
import dayjs from 'dayjs'

type Props = {
  value?: string
  placeholder?: string
  error?: boolean
  size?: 'big'
  inputClassName?: string
  onChange: (value: string) => void
}

export const BirthDatePicker: React.FC<Props> = ({
  value = '',
  placeholder,
  error = null,
  size = '',
  inputClassName = '',
  onChange = () => {},
}) => {
  const { t } = useTranslation()
  const className = [error ? 'error' : '', size, inputClassName].filter(Boolean).join(' ')

  mobiscroll.settings = {
    dateFormat: 'yy/mm/dd',
    dateWheels: 'yy mm dd',
    theme: 'mobiscroll',
    themeVariant: 'light',
    width: '505',
  }

  return (
    <>
      <mobiscroll.Date
        value={value}
        defaultValue={value || '1985/01/01'}
        touchUi={false}
        onChange={event => onChange(event.valueText)}
        display="bubble"
        min={dayjs().subtract(120, 'year').format('YYYY-MM-DD')}
        max={dayjs().subtract(15, 'year').format('YYYY-MM-DD')}
      >
        <mobiscroll.Input className={className} placeholder={placeholder || t('Please select')} inputStyle="box" />
      </mobiscroll.Date>
    </>
  )
}
